import React from 'react'
import { useDispatch } from 'react-redux'

import { Dialog, Fade, StyledEngineProvider, ThemeProvider, Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'

import AcquiringSettlementTable from 'components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsViewModal/AcquiringSettlementModalTable'
import { newFormThemeOverrides } from 'components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsViewModal/styles'
import { finishErrorAlert } from 'redux/alert/alert-actions'
import { themeStyles, useTheme } from 'themes'

interface AcquiringSettlementsProps {
    classes: Record<string, string>
    children: React.ReactNode
    record: ParsedRecord
}

const AcquiringSettlements: React.FC<AcquiringSettlementsProps> = ({ classes, children, record }) => {
    const dispatch = useDispatch()
    const { formTheme } = useTheme({ formTheme: newFormThemeOverrides })
    const [open, setOpen] = React.useState(false)

    const handleOpen = () => setOpen(true)
    const handleClose = () => {
        dispatch(finishErrorAlert())
        setOpen(false)
    }

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={formTheme}>
                <Typography component="div" onClick={handleOpen} style={{ width: '100%', height: '100%' }}>
                    {children}
                </Typography>
                <Dialog
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    classes={{ paper: classes.paperDialogWidth, container: classes.MuiDialogContainer }}
                >
                    <Fade in={open}>
                        <div className={classes.paperDialog}>
                            <AcquiringSettlementTable record={record} handleClose={handleClose} />
                        </div>
                    </Fade>
                </Dialog>
            </ThemeProvider>
        </StyledEngineProvider>
    )
}

export default withStyles(themeStyles.useModalStyles)(AcquiringSettlements)
